var AppDispatcher = require('../core/AppDispatcher.jsx');
var ActionTypes = require('../constants/CongratulationsConstants.js').ActionTypes;

module.exports = {
    downloadAllResponse: function(data, isError){
        AppDispatcher.dispatch({
            actionType: ActionTypes.RESPONSE_DOWNLOAD_ALL,
            data,
            isError
        });
    },
    downloadFormSuccess: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DOWNLOAD_FORM_SUCCESS,
            data: data
        });
    },
    downloadFormFailed:function() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DOWNLOAD_FORM_FAILED
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/CongratulationsApiCallBackActions.js